import { ds } from "@/deal-room/theme/ds";

// The design system's `.bc-table` (assets/brand/design-system.html), as MUI
// sx: navy header with white uppercase labels, 13px gray-700 body, gray-200
// rules and frame, radius 8, gray-50 hover. The staff directory and the
// access panel both draw from here (Bill, 2026-09-24: on brand, grid-like).
export const bcTableFrame = {
    bgcolor: ds.white,
    border: `1px solid ${ds.gray200}`,
    borderRadius: `${ds.radius}px`,
    overflow: "hidden",
} as const;

export const bcTh = {
    bgcolor: ds.navy,
    color: ds.white,
    fontSize: ds.text.xs,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    lineHeight: 1.3,
    px: 2,
    py: 1.5,
    borderBottom: "none",
    whiteSpace: "nowrap",
} as const;

export const bcTd = {
    fontSize: ds.text.sm,
    color: ds.gray700,
    px: 2,
    py: 1.25,
    borderBottom: `1px solid ${ds.gray200}`,
    "tr:last-child &": { borderBottom: "none" },
} as const;

export const bcRow = { "&:hover": { bgcolor: ds.gray50 } } as const;

// The public site's text input (SignIn.tsx `site.input`): white, gray-200
// border, 8px radius, a slightly darker border on focus.
export const siteInput = {
    "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
        bgcolor: ds.white,
        fontSize: "0.875rem",
        color: ds.navy,
        "& fieldset": { borderColor: ds.gray200 },
        "&:hover fieldset": { borderColor: ds.gray200 },
        "&.Mui-focused fieldset": { borderColor: "#b3b9c6", borderWidth: 1 },
    },
    "& .MuiOutlinedInput-input": { px: 1.5, py: 1.25 },
} as const;
